const ms = require('ms')
const _ = require('lodash')
const fetch = require('@adc/fetch')
const configment = require('@adc/configment')

const embeddableOperation = name =>
  [_.camelCase(configment.get('APP_NAME', '')), name].filter(Boolean).join('_')

const domainEventsPayload = events => ({
  query: `
    mutation ${embeddableOperation('instrument_domainEvents')}(
      $events: [DomainEventInput!]!
    ) {
      domainEvents(events: $events)
    }
  `,
  variables: {
    events,
  },
})

const sendDomainEvents = events =>
  fetch.forAuctionGraph(domainEventsPayload(events), {
    requestTimeout: ms('2s'),
  })

const domainEvent = event => sendDomainEvents([event])

module.exports = {
  domainEventsPayload,
  sendDomainEvents,
  domainEvent,
}
